
import RealTimeData from "./RealTimeData";
import BotTrades from "./BotTrades";
import { useEffect, useState } from "react";
import { SellPumpToken, buyPumpToken } from "../Transactions";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import { MdDangerous } from "react-icons/md";
import axios from "axios";
import DemoCreatedTokens from "./DemoCreatedTokens";
import DemoOpportunities from "./DemoOpportunities";

export default function DataView({ profitableTokens, tradingActive, liveTradesData, pumpSocket, setTradingActive }) {

  const [deletedTemp, setDeletedTemp] = useState({})

  const [userTrades, setUserTrades] = useState({})
  const [trailingStop, setTrailingStop] = useState({})
  const [takeProfits, setTakeProfits] = useState({})
  const [sellingHistory, setSellingHistory] = useState({})
  const [realtimeMarketCaps, setRealtimeMarketCaps] = useState({})
  const [tempTrades, setTempTrades] = useState({})
  const [pendingTransaction, setPendingTransaction] = useState(false)


  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const { bot } = useSelector(state => state.session)

  const botSettings = bot

  const showToast = (title, description, params) => {

    toast(title, {
      className: ` opacity-95 shadow text-neutral-200 border-neutral-700 ${params?.type == "buy" ? "bg-green-800" : "bg-neutral-900"} `,
      description: description,
      duration: params?.duration || 5000,
      position: params?.position || 'top-left',
      dismissible: true,
    });
  }



  const getURIData = async (endpoint) => {
    let score = 0

    try {

      const res = await axios.get(endpoint).then((res) => res.data)
      const telegram = res?.telegram
      const website = res?.website
      const twitter = res?.twitter
      let metadata = res
      const xRegex = /^(https?:\/\/)?(www\.)?x\.com\/[A-Za-z0-9_]+$/;

      if (website && bot.website) {
        score += 1
      }
      if (twitter && bot.twitter) {
        if (xRegex.test(twitter)) {
          score += 1
        }
      }
      if (telegram && bot.telegram) {
        score += 1
      }

      let soc = { website, twitter, telegram }

      return { score, metadata }

    } catch (err) {
      console.log(err?.message)
    }


  }





  const addTempTrades = async (token) => {
    setTempTrades((prev) => ({
      ...prev,
      [token?.mint]: token
    }))
  }


  const stats = () => {
    return Object.keys(sellingHistory).reduce((acc, mint) => {
      const { isWinning } = sellingHistory[mint];

      if (isWinning === 'win') {
        acc.win += 1;
      } else if (isWinning === 'loss') {
        acc.loss += 1;
      } else {
        acc.neutral += 1;
      }
      return acc;
    }, { win: 0, loss: 0, neutral: 0 });
  };

  let { win, loss, neutral } = stats()

  const deleteTrade = (mint) => {

    setUserTrades((prev) => {
      const newState = { ...prev }
      delete newState[mint]
      return newState
    })

    setTakeProfits((prev) => {
      const newState = { ...prev }
      delete newState[mint]
      return newState
    })
    setTrailingStop((prev) => {
      const newState = { ...prev }
      delete newState[mint]
      return newState
    })
    setTempTrades((prev) => {
      const newState = { ...prev }
      delete newState[mint]
      return newState
    })
    setDeletedTemp((prev) => ({
      ...prev,
      [mint]: true
    }))
  }


  function getOwnerHolding(token) {
    let vbc = Number(token?.vTokensInBondingCurve)
    let oh = Number(token?.initialBuy)
    let percent = (oh / vbc) * 100
    return percent
  }

  const calculateTokenRisk = (token) => {
    let pc = getOwnerHolding(token)
    if (pc >= botSettings?.ownerTokenHoldings) {
      return true
    } else {
      return false
    }
  }


  const sellMarket = async (token, isWinning) => {
    setPendingTransaction(true)
    let { mint } = token
    let trade = userTrades[mint]
    let deleted = deletedTemp[mint]
    let uiToken = {
      ...trade,
      ...token,
      isWinning: isWinning,
      buyMc: trade?.marketCapSol,
      sellMc: realtimeMarketCaps[mint]
    }

    if (trade && !deleted) {
      // const transaction = true
      const transaction = await SellPumpToken(botSettings, mint)

      if (transaction) {
        unsubscribeTokenTrade(mint)
        showToast("Selling..", `Solde ${trade.name} at ${Number(realtimeMarketCaps[mint]).toFixed(2)} marketCap`, 'sell')
        setSellingHistory((prev) => ({
          ...prev,
          [mint]: uiToken
        }))
        deleteTrade(mint)
        setPendingTransaction(false)
      } else if (transaction.error) {
        toast.error('error processing Sell')
      }
    }
  }

  const modifyTrailing = (mint, value) => {
    setTrailingStop((prev) => ({
      ...prev,
      [mint]: Number(value)
    }))
  }

  const addBuyTrade = async (token, metadata) => {
    let tokenMC = Number(token?.marketCapSol)
    let ts = tokenMC - Number(botSettings.stopLoss)
    let tp = tokenMC + Number(botSettings.sellMc)
    setUserTrades((prev) => ({
      ...prev,
      [token?.mint]: { ...token, metadata }
    }))
    modifyTrailing(token?.mint, ts)

    setTakeProfits((prev) => ({
      ...prev,
      [token?.mint]: tp
    }))
  }

  const addUpdatedTrade = async (message) => {
    let token = tempTrades[message.mint]
    let found = {
      ...token,
      ...message,
    }
    await addBuyTrade(found)
  }



  const buyMarket = async (token) => {

    const found = tempTrades[token.mint]

    if (Object.keys(userTrades).length < Number(botSettings.maxOpenTrades) && !found) {
      setPendingTransaction(true)
      addTempTrades(token)
      let transaction = await buyPumpToken(botSettings, token?.mint)


      if (transaction && !transaction?.error) {
        subscribeTokenTrade(token?.mint)
        showToast("Buy token", `buying ${token.name} `, { type: 'buy' })
        setPendingTransaction(false)
        await addBuyTrade(token)
      } else if (transaction?.error) {
        showToast("Transaction error ...", `could not buy ${token.name} `, { type: 'sell' })
        setPendingTransaction(false)
        // unsubscribeTokenTrade(token?.mint)
        setTempTrades((prev) => {
          const newState = { ...prev }
          delete newState[token.mint]
          return newState
        })
        deleteTrade(token.mint)

      }
    }
  }

  const checkBuyOpportunities = async (token) => {


    if (Object.keys(userTrades).length < Number(botSettings.maxOpenTrades)) {
      const risky = calculateTokenRisk(token)
      //checks if the user has selected a social filtering option
      if (bot.telegram || bot.twitter || bot.website) {
        const { score, metadata } = await getURIData(token.uri)
        if (score >= [bot.twitter, bot.telegram, bot.website].filter(value => value == true).length) {
          if (!risky) {
            // await buyMarket(token)
            await addBuyTrade(token, metadata)

          }
        } else {
          return false
        }
      } else {
        if (!risky) {
          // await buyMarket(token)
          const { score, metadata } = await getURIData(token.uri)
          await addBuyTrade(token, metadata)

        }
      }
    }
  }


  const isInProfits = async (message) => {
    // const found = userTrades.find(trade => trade.mint == message.mint)
    const found = userTrades[message.mint]
    const newMC = Number(message.marketCapSol)
    const stopLoss = Number(userTrades[message?.mint]?.marketCapSol) - Number(botSettings.stopLoss)

    let Tp = Number(takeProfits[message.mint])
    let trailing = Number(trailingStop[message.mint])
    let prevTrailing = trailing
    if (found && deletedTemp[message.mint] !== true) {
      if (newMC >= Tp) {
        await sellMarket(message, 'win')
        return true
      } else if (newMC <= stopLoss) {
        await sellMarket(message, 'loss')
      } else if (newMC <= trailing) {
        await sellMarket(message, 'trailing')
      }
      else {
        let newTrailing = (botSettings.stopLoss * 2) + prevTrailing
        if (newMC >= newTrailing) {

          let newTs = newMC - Number(botSettings.stopLoss)
          modifyTrailing(message.mint, newTs)
        }
        // tradeEmitter.emit('newTrade', { type: "trade",trade_type:'update',marketCapSol:newMC ,mint:message.mint })
        return false
      }
    } else {
      console.log(`token ${message.mint} not found or already solde`)
    }
  }

  const checkTokenForSell = async (message) => {
    if (deletedTemp[message?.mint]) {
      return
    } else {
      isInProfits(message)
    }
  }

  function subscribeTokenTrade(tokenAddress) {
    if (pumpSocket?.readyState === WebSocket.OPEN) {
      pumpSocket.send(JSON.stringify({
        "method": "subscribeTokenTrade",
        "keys": [tokenAddress]
      }));  // Send the payload as a JSON string
    } else { console.error('External WebSocket is not open'); }
  }

  function unsubscribeTokenTrade(tokenAddress) {
    if (pumpSocket?.readyState === WebSocket.OPEN) {
      pumpSocket.send(JSON.stringify({
        "method": "unsubscribeTokenTrade",
        "keys": [tokenAddress]
      }));  // Send the payload as a JSON string
    } else { console.error('External WebSocket is not open'); }
  }

  function unsubscribeNewToken() {
    if (pumpSocket?.readyState === WebSocket.OPEN) {
      pumpSocket.send(JSON.stringify({ method: "unsubscribeNewToken" }));
    } else { console.error('External WebSocket is not open'); }
  }

  const emergencyShutDown = async () => {
    if (pumpSocket?.readyState === WebSocket.OPEN) {
      toast('Trading is being Stopped ...')
      let trades = Object.keys(userTrades);
      if (trades.length > 0) {
        for (const token of trades) {
          try {
            await sellMarket(userTrades[token], "sell")
            // if (trades[trades.length - 1] == token) {
            // }

            if (trades[0] == token) {
              setTradingActive(false)
              unsubscribeNewToken()
              pumpSocket.close()
            } else {

              if (trades[trades.length - 1] == token) {
                setTradingActive(false)
                unsubscribeNewToken()
                pumpSocket.close()
              }

            }

          } catch (error) {
            console.error(`Error processing trade for ${token}:`, error);
            // Handle error (e.g., retry, alert user, etc.)
          }
        }
      } else {
        setTradingActive(false)
        unsubscribeNewToken()
        pumpSocket.close()
        console.log('No open trades to stop.')
      }
    } else {
      console.log('WebSocket is not open, cannot stop trading.');
    }
  };

  const updateMC = (mint, mc) => {
    setRealtimeMarketCaps((prev) => ({
      ...prev,
      [mint]: mc
    }
    ))
  }


  //////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {

    if (Object.keys(userTrades).length >= botSettings.maxOpenTrades) {

      pumpSocket.close()
      toast.info('Demo Test Has Ended !',{duration:6000})

    }

    if (profitableTokens?.txType == "create") {
      if (Object.keys(userTrades).length < Number(botSettings.maxOpenTrades) && tradingActive && profitableTokens?.mint && Object.keys(tempTrades).length < Number(botSettings.maxOpenTrades)) {
        console.log('checking buy opportunity ...')
        checkBuyOpportunities(profitableTokens)
      }
    }
  }, [profitableTokens])

  // useEffect(() => {
  //   if (Object.keys(userTrades).length > 0) {
  //     checkTokenForSell(liveTradesData)
  //     updateMC(liveTradesData?.mint, liveTradesData?.marketCapSol)
  //   }
  //   if (liveTradesData?.traderPublicKey == botSettings.address && liveTradesData.txType == "buy") {
  //     addUpdatedTrade(liveTradesData)
  //     console.log({ found: liveTradesData })
  //   }
  // }, [liveTradesData])


  //////////////////////////////////////////////////////////////////////////////////////

  return (

    <div className="grid gap-5 pb-20 sm:pb-10 md:pb-0">
      {
        <div className="h-max  w-full  flex gap-5 flex-wrap ">
          <div className={` border-l-2 rounded-lg border-green-900 bg-gradient-to-tl from-neutral-900 to-transparent p-2 grow    hover:bg-neutral-800 hover:border-yellow-900 relative transition-all`}>
            <div className='flex flex-col items-start justify-start gap-2 p-2'>
              <p className='text-xs font-bold text-neutral-300'>Winning Trades</p>
              <p className='font-bold text-green-600 text-2xl '>{win}</p>
            </div>
          </div>
          <div className={` border-l-2 rounded-lg border-red-900 bg-gradient-to-tl from-neutral-900 to-transparent p-2 grow    hover:bg-neutral-800 hover:border-yellow-900 relative transition-all`}>
            <div className='flex flex-col items-start justify-start gap-2 p-2'>
              <p className='text-xs font-bold text-neutral-300'>Stop Loss Hits</p>
              <p className='font-bold text-red-600 text-2xl '>{loss}</p>
            </div>
          </div>
          <div className={` border-l-2 rounded-lg border-yellow-900 bg-gradient-to-tl from-neutral-900 to-transparent p-2 grow    hover:bg-neutral-800 hover:border-yellow-900 relative transition-all`}>
            <div className='flex flex-col items-start justify-start gap-2 p-2'>
              <p className='text-xs font-bold text-neutral-300'>Neutral / Break even</p>
              <p className='font-bold text-yellow-600 text-2xl '>{neutral}</p>
            </div>
          </div>

          {tradingActive &&
            <div className={`  rounded-lg   p-2 grow  `}>
              <div className='flex flex-col h-full items-center justify-center gap-2 p-2'>
                <span className="w-max gap-1 bg-red-500 rounded-full p-1 items-center jusitfy-center flex hover:cursor-pointer hover:bg-red-500 transition-all hover:scale-110" onClick={emergencyShutDown} >
                  <MdDangerous className="text-white text-3xl " />
                  <span className="text-white text-[10px] ">Emergency shut dow</span>
                </span>
                <span className="text-white text-[10px] ">will stop The connection and sell all open positions</span>
              </div>
            </div>
          }
        </div>
      }
      <div className="w-full " >
        <div className="grid">

 
          <div className=" w-full grid grid-cols-1 lg:grid-cols-2 gap-5">
            <DemoCreatedTokens token={profitableTokens} />
            <DemoOpportunities tokens={userTrades} />
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-5 min-w-[320px] max-w-[460px]   sm:max-w-full">








        <BotTrades realtimeMarketCaps={realtimeMarketCaps} sellMarket={sellMarket} userTrades={{}} socket={pumpSocket} botSettings={botSettings} />
        <RealTimeData sellingHistory={sellingHistory} />
      </div>
    </div>
  )
}